@switch (stage()) {
@case ('intake') {
<div class="h-full w-full flex flex-col justify-start items-center overflow-y-auto w-full">
    <div class="mx-auto max-w-7xl px-6 py-14">
        <span
            class="mb-5 inline-flex items-center gap-2 rounded-full bg-brand-studio/10 px-3.5 py-1.5 text-xs font-bold text-brand-studio-dark dark:text-brand-studio">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
            </svg>
            Powered by SHOUT AI
        </span>
        <h1 class="font-heading text-5xl font-bold leading-[0.9] tracking-tight sm:text-6xl">What are we<br /><span
                class="text-brand-studio">shouting about?</span></h1>
        <p class="mt-4 max-w-3xl text-base text-muted-foreground">Describe your campaign in a sentence or two. SHOUT AI
            drafts
            the concepts, creative steps, do's &amp; don'ts — you review and refine.</p>


        <div class="mt-9" data-guide-id="createBrief.productSection">
            <div class="mb-2.5 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">Which product?
            </div>

            @if (products().length) {
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
                @for (product of products(); track product.id) {
                <div (click)="service.selectedProduct.set(product)"
                    class="relative flex items-center space-x-3 rounded-lg border bg-white px-3 py-2 shadow-xs dark:bg-gray-800/50 dark:shadow-none cursor-pointer"
                    [class]="service.selectedProduct()?.id === product.id ? 'border-brand-studio bg-brand-studio/[0.06] ring-2 ring-brand-studio/20' : 'border-border bg-card hover:border-foreground/30'">
                    <div class="shrink-0">
                        <img [src]="imageService.getImageSource(product.productImage, 'gallery')" alt=""
                            class="size-10 rounded-sm bg-gray-300 outline -outline-offset-1 outline-black/5 dark:bg-gray-700 dark:outline-white/10" />
                    </div>
                    <div class="min-w-0 flex-1">
                        <a class="focus:outline-hidden">
                            <span aria-hidden="true" class="absolute inset-0"></span>
                            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ product.productName }}</p>
                            <p class="truncate text-sm text-gray-500 dark:text-gray-400">{{ product.productCategory }}
                            </p>
                        </a>
                    </div>
                </div>
                }
            </div>
            }
            @else {
            <p class="text-sm text-muted-foreground">No saved products found — you can add one in the review step.</p>
            }
        </div>

        <div class="mt-8">
            <div class="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">Describe the brief...
            </div>

            <div
                class="mt-2.5 overflow-hidden rounded-xl border border-border bg-card shadow-md focus-within:border-brand-studio focus-within:ring-4 focus-within:ring-brand-studio/20">
                <textarea [value]="prompt()" (input)="prompt.set($any($event.target).value)"
                    data-guide-id="createBrief.aiPrompt"
                    placeholder="e.g. We're launching our new productivity app and want relatable creators showing how it saves them an hour a day at work…"
                    class="min-h-24 w-full resize-none border-none bg-transparent px-6 pb-2 pt-5 text-lg outline-none placeholder:text-muted-foreground"></textarea>
                <div class="flex items-center gap-3 px-4 pb-3.5 pt-2">
                    <div class="flex-1"></div>
                    <button type="button" class="flashy-go-button" data-guide-id="createBrief.draft" (click)="generate()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                        </svg>
                        Draft my brief
                    </button>
                </div>
            </div>
        </div>

        <div class="mt-6">
            <p class="text-xs font-medium text-secondary text-center mb-3">Try an example</p>
            <div class="flex flex-wrap items-center justify-center gap-2">
                @for (example of examplesExtended; track example) {
                <button type="button" (click)="prompt.set(example.prompt)"
                    class="inline-flex items-center rounded-full px-3 py-1.5 text-xs font-medium bg-primary/10 text-accent ring-1 ring-inset ring-primary/15 hover:bg-primary/15 transition-colors cursor-pointer">{{
                    example.name }} - {{ example.description }}</button>
                }
            </div>
        </div>
    </div>
</div>
}

@case ('generating') {
<bb-ai-drafting-loader [thoughts]="briefAi.streamingThoughts()" [isCompiling]="briefAi.isCompilingBrief()" />
}

@case ('review') {

<div class="h-full min-h-0 w-full flex flex-col justify-start items-center overflow-hidden w-full">
    <div class="w-full h-full min-h-0 grid grid-cols-4 gap-2">
        <!-- Main Content -->
        <div class="col-span-3 h-full overflow-hidden flex flex-col gap-y-2">
            <div class="w-full flex-1 overflow-hidden">
                <div class="h-full overflow-y-auto">
                    <div class="mx-auto max-w-7xl px-6 sm:px-12">

                        <!-- General Header -->
                        <div
                            class="mb-5 flex items-center gap-3.5 rounded-xl bg-gradient-to-br from-brand-studio-dark to-brand-studio px-5 py-4 text-white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path
                                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                            </svg>
                            <div>
                                <div class="font-heading text-lg font-bold leading-none">SHOUT AI has drafted
                                    your
                                    brief</div>
                                <div class="mt-1 text-[12.5px] opacity-85">Everything below is a starting point
                                    — edit any
                                    field.
                                    Nothing goes live until you launch.</div>
                            </div>
                        </div>
                        <!-- General Header - END -->

                        @for (section of reviewSections; track section.id) {
                        <section class="mb-4 rounded-xl border border-border p-6 shadow-md">
                            <div class="mb-4 flex items-center gap-2.5">
                                <span class="font-heading text-xl font-bold">{{ section.title }}</span>
                                @if (section.id === 'creative') {
                                <button type="button" [disabled]="aiBusy()" (click)="regenerateCreative()"
                                    class="ml-auto inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-xs font-bold text-brand-studio-dark hover:border-brand-studio hover:bg-brand-studio/10 disabled:opacity-50 dark:text-brand-studio">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                                        <path d="M21 3v5h-5" />
                                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                                        <path d="M8 16H3v5" />
                                    </svg>
                                    {{ aiBusy() ? 'Regenerating…' : 'Regenerate' }}
                                </button>
                                }
                            </div>
                            @switch (section.id) {
                            @case ('brief') { <bb-brief-basics-section /> }
                            @case ('product') { <bb-product-section /> }
                            @case ('content') { <bb-content-section /> }
                            @case ('creative') { <bb-creative-section /> }
                            @case ('audience') { <bb-audience-section /> }
                            @case ('screening') { <bb-screening-section /> }
                            }
                        </section>
                        }

                        <section class="mb-4 rounded-xl border border-border p-6 shadow-md">
                            <bb-compensation-section />
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <!-- Main Content - END -->

        <!-- Right Hand Sidebar - Summary -->
        <div class="col-span-1 h-full min-h-0 rounded-xl border border-gray-200 dark:border-white/10">
            <div class="h-full min-h-0 flex flex-col overflow-hidden divide-y divide-border">
                <!-- header -->
                <div class="shrink-0 px-2 py-4 drawer-header-primary overflow-hidden rounded-t-xl">
                    <div class="flex space-x-3 h-full items-center">
                        <div class="min-w-0 flex-1 px-2">
                            <p class="text-md font-semibold text-primary">
                                Brief Drafted!
                            </p>
                            <p class="text-sm text-secondary">
                                Review the draft and make changes before launching.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- header - END -->
                <!-- main content -->
                <div class="min-h-0 flex-1 overflow-y-auto p-2">
                    <bb-summary-card />
                </div>
                <!-- main content - END -->

                <!-- Footer -->
                <div
                    class="shrink-0 px-2 py-2 drawer-header-primary overflow-hidden rounded-b-xl flex flex-row items-center justify-between">
                    <button (click)="startOver.emit()" type="button"
                        class="inline-flex items-center gap-x-1.5 rounded-md bg-transparent px-2.5 py-1.5 text-sm font-semibold text-brand-studio hover:bg-brand-studio/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-studio dark:hover:bg-brand-studio/10 dark:focus-visible:outline-brand-studio">
                        Start over
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="-mr-0.5 size-5">
                            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                            <path d="M3 3v5h5" />
                        </svg>
                    </button>

                    <button (click)="launch.emit()" type="button" class="flashy-go-button disabled:opacity-50"
                        [disabled]="!canLaunch()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                            <path
                                d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09" />
                            <path
                                d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z" />
                            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" />
                        </svg>
                        Launch brief
                    </button>
                </div>
                <!-- Footer - END -->
            </div>
            <!-- Right Hand Sidebar - Summary - END -->
        </div>
    </div>
</div>


}
}